<template>
  <div class="content">
    <div class="page-title flex align-center just-content-between">
      <div class="flex">
        <p>{{ pageTitle }}</p>
        <p class="u-ml30">{{ tabs + 1 }} / {{ tabsMax + 1 }}</p>
      </div>
      <div class="flex align-center u-ml40 u-mr20" style="font-size: 14px">
        <span class="icon" style="">
          <font-awesome-icon icon="user" size="2x"></font-awesome-icon>
        </span>
        <p class="u-mr10 u-ml5 u-mb0">{{ schoolYear }}</p>
        <p class="u-mb0">{{ childName }}</p>
      </div>
    </div>
    <OrganismsAnchorLink
      :anchorLinks="useDefine.defineObject.NAV_BASIC_SURVEY_4_ANCHORS_ARRAY"
      @goToPageAnchor="goToPage"
    />

    <p class="prohibited-text">
      ※ブラウザの戻るボタン/再読み込みは使用しないでください。<br />入力中のデータが正しく処理されません。
    </p>
    <div class="form-wrap">
      <div class="tab -0" v-if="tabs === 0">
        <section class="form-section u-mb20">
          <div class="contents-wrap u-mt0">
            <atoms-sub-label index="4-1" label="記入者情報" />
            <atoms-input-text
              class="u-mb30"
              label="記入者"
              type="text"
              placeholder="記入者"
              inputmode="text"
              :required="false"
              v-model="formData.writer"
              setKey="writer"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>
          <atoms-label label="服薬状況" />
          <div class="contents-wrap">
            <atoms-sub-label index="4-2" label="服薬状況" />
            <atoms-input-textarea
              label="服薬状況"
              placeholder="服薬状況"
              :required="false"
              v-model="formData.medicationStatus"
              setKey="medicationStatus"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-select
              label="内服"
              v-model="formData.medicationStatusOral"
              setKey="medicationStatusOral"
              :options="useDefine.defineObject.ORAL_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="感染症"
              v-model="formData.medicationStatusInfection"
              setKey="medicationStatusInfection"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-select
              label="該当する感染症"
              v-model="formData.medicationStatusHaveInfection"
              setKey="medicationStatusHaveInfection"
              :options="useDefine.defineObject.HAVEINFECTION_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-textarea
              :label="`その他`"
              placeholder="その他"
              :required="false"
              v-model="formData.medicationStatusOtherwise"
              setKey="medicationStatusOtherwise"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -1" v-if="tabs === 1">
        <section class="form-section u-mb20">
          <atoms-label label="身体状況" />

          <div class="contents-wrap">
            <atoms-sub-label index="4-3" label="身体状況" />
            <atoms-input-textarea
              :label="`一般状態`"
              placeholder="一般状態"
              :required="false"
              v-model="formData.physicalConditionGeneralState"
              setKey="physicalConditionGeneralState"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="`栄養状態`"
              placeholder="栄養状態"
              :required="false"
              v-model="formData.physicalConditionNutritionalStatus"
              setKey="physicalConditionNutritionalStatus"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>

          <div class="contents-wrap">
            <atoms-sub-label index="4-4" label="口腔状態" />
            <atoms-input-radio
              label="義歯"
              v-model="formData.physicalConditionOralConditionsArtificialTooth"
              setKey="physicalConditionOralConditionsArtificialTooth"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-select
              label="義歯が有の場合"
              v-model="
                formData.physicalConditionOralConditionsHaveArtificialTooth
              "
              setKey="physicalConditionOralConditionsHaveArtificialTooth"
              :options="useDefine.defineObject.HAVEARTIFICIALTOOTH_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-radio
              label="歯痛"
              v-model="formData.physicalConditionOralConditionsToothache"
              setKey="physicalConditionOralConditionsToothache"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="しみる"
              v-model="formData.physicalConditionOralConditionsSmarting"
              setKey="physicalConditionOralConditionsSmarting"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="動揺痛"
              v-model="formData.physicalConditionOralConditionsUpsetPain"
              setKey="physicalConditionOralConditionsUpsetPain"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="歯肉の炎症"
              v-model="
                formData.physicalConditionOralConditionsInflammationOfGums
              "
              setKey="physicalConditionOralConditionsInflammationOfGums"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="口臭"
              v-model="formData.physicalConditionOralConditionsBadBreath"
              setKey="physicalConditionOralConditionsBadBreath"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-radio
              label="食物残査"
              v-model="formData.physicalConditionOralConditionsFoodResidue"
              setKey="physicalConditionOralConditionsFoodResidue"
              :options="useDefine.defineObject.YES_AND_NO_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
              :is-tap="true"
            ></atoms-input-radio>

            <atoms-input-textarea
              label="その他"
              placeholder="その他"
              :required="false"
              v-model="formData.physicalConditionOtherwise"
              setKey="physicalConditionOtherwise"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>

            <atoms-input-textarea
              :label="
                `機能障害の程度・皮膚の状態\n（麻痺・関節の状態・発赤・浮腫・褥創等）`
              "
              placeholder="麻痺・関節の状態・発赤・浮腫・褥創等"
              :required="false"
              v-model="formData.physicalConditionDegreeOfDisability"
              setKey="physicalConditionDegreeOfDisability"
              @input-emit="handleUpdateValue"
            ></atoms-input-textarea>
          </div>
        </section>
      </div>

      <div class="tab -2" v-if="tabs === 2">
        <section class="form-section u-mb20">
          <atoms-label label="睡眠" />

          <div class="contents-wrap">
            <atoms-sub-label index="4-5" label="睡眠" />

            <atoms-input-select
              label="睡眠"
              v-model="formData.sleep"
              setKey="sleep"
              :options="useDefine.defineObject.SLEEP_OPTION_ARRAY"
              @input-emit="handleUpdateValue"
            ></atoms-input-select>

            <atoms-input-text
              label="睡眠時間"
              type="text"
              placeholder="8時間"
              inputmode="text"
              :required="false"
              v-model="formData.sleepTimeOfSleeping"
              setKey="sleepTimeOfSleeping"
              @input-emit="handleUpdateValue"
            ></atoms-input-text>
          </div>

          <div class="contents-wrap">
            <atoms-label label="生活歴" />

            <div class="contents-wrap">
              <atoms-sub-label index="4-6" label="生活歴" />
              <atoms-input-textarea
                :label="
                  `生活歴\n（※児童・知的障害・発達障害については省略可（基礎調査資料2作成による））`
                "
                placeholder="生活歴"
                :required="false"
                v-model="formData.lifeHistory"
                setKey="lifeHistory"
                @input-emit="handleUpdateValue"
              ></atoms-input-textarea>
            </div>
          </div>

          <div class="contents-wrap">
            <atoms-label label="嗜好" />

            <div class="contents-wrap">
              <atoms-sub-label index="4-7" label="嗜好" />
              <atoms-input-radio
                label="飲酒"
                v-model="formData.preferenceDrinking"
                setKey="preferenceDrinking"
                :options="useDefine.defineObject.DRINKING_OPTION_ARRAY"
                @input-emit="handleUpdateValue"
                :is-tap="true"
              ></atoms-input-radio>

              <atoms-input-text
                label="一日の飲酒量"
                type="text"
                placeholder="500ml"
                inputmode="text"
                :required="false"
                v-model="formData.preferenceDrinkingAmount"
                setKey="preferenceDrinkingAmount"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>

              <atoms-input-radio
                label="喫煙"
                v-model="formData.preferenceSmoking"
                setKey="preferenceSmoking"
                :options="useDefine.defineObject.SMOKING_OPTION_ARRAY"
                @input-emit="handleUpdateValue"
                :is-tap="true"
              ></atoms-input-radio>

              <atoms-input-text
                label="一日の喫煙量"
                type="text"
                placeholder="2本"
                inputmode="text"
                :required="false"
                v-model="formData.preferenceSmokingAmount"
                setKey="preferenceSmokingAmount"
                @input-emit="handleUpdateValue"
              ></atoms-input-text>
            </div>
          </div>

          <div class="contents-wrap">
            <atoms-label label="社会的活動等" />

            <div class="contents-wrap">
              <atoms-sub-label index="4-8" label="社会的活動等" />
              <atoms-input-select
                label="集団への不適応"
                v-model="formData.socialActivitiesMaladaptiveToThePopulation"
                setKey="socialActivitiesMaladaptiveToThePopulation"
                :options="
                  useDefine.defineObject.MALADAPTIVETOTHEPOPULATION_OPTION_ARRAY
                "
                @input-emit="handleUpdateValue"
              ></atoms-input-select>

              <div class="contents-wrap">
                <atoms-sub-label
                  index="4-9"
                  :label="`1日の過ごし方\n家庭内での役割・日課`"
                />

                <organisms-input-group-array-homerole-and-daily-routine
                  label="none"
                  v-model="formData.socialActivitiesHomeroleAndDailyRoutine"
                  setArrayKey="socialActivitiesHomeroleAndDailyRoutine"
                  :dataMax="5"
                  @input-emit="handleUpdateArrayValue"
                  @add-array="handleAddArray"
                  @remove-array="handleRemoveArray"
                ></organisms-input-group-array-homerole-and-daily-routine>

                <atoms-input-textarea
                  :label="`外出頻度/外出先`"
                  placeholder="外出頻度/外出先"
                  :required="false"
                  v-model="formData.socialActivitiesAboutGoingOut"
                  setKey="socialActivitiesAboutGoingOut"
                  @input-emit="handleUpdateValue"
                ></atoms-input-textarea>

                <atoms-input-textarea
                  :label="`相談相手知人・近所との交流`"
                  placeholder="相談相手知人・近所との交流"
                  :required="false"
                  v-model="formData.socialActivitiesAlternatingCurrent"
                  setKey="socialActivitiesAlternatingCurrent"
                  @input-emit="handleUpdateValue"
                ></atoms-input-textarea>

                <atoms-input-textarea
                  :label="`趣味生きがい楽しみ`"
                  placeholder="趣味生きがい楽しみ"
                  :required="false"
                  v-model="formData.socialActivitiesHobby"
                  setKey="socialActivitiesHobby"
                  @input-emit="handleUpdateValue"
                ></atoms-input-textarea>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="check_button_wrap prev_and_next">
        <div class="prev">
          <atoms-note-button
            v-if="tabs > tabsMin"
            buttonText="前の項目へ"
            @confirm="handlePrevTabs"
          />
        </div>
        <div class="next">
          <atoms-note-button
            v-if="tabs < tabsMax"
            buttonText="次の項目へ"
            @confirm="handleNextTabs"
          />
        </div>
      </div>
    </div>
    <div class="form-tabs" v-if="nextPageTitle">
      <atoms-note-button
        :buttonText="`${nextPageTitle}へ`"
        @confirm="handleUpdateFormTab"
      />
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import formUtils from '@/lib/formUtils/form-utils'

import OrganismsInputGroupArrayHomeroleAndDailyRoutine from '@/components/organisms/OrganismsInputGroupArrayHomeroleAndDailyRoutine.vue'
import OrganismsAnchorLink from '@/components/organisms/basicSurvey/OrganismsAnchorLink.vue'
export default {
  components: {
    OrganismsInputGroupArrayHomeroleAndDailyRoutine,
    OrganismsAnchorLink,
  },
  data() {
    return {
      tabsMin: 0,
      tabsMax: 2,
      tabs: 0,
      // formの選択肢
      useDefine: { defineObject: defineObject },
      // emit対象のformデータ
      formData: {
        createdDate: '',
        lastName: '',
        firstName: '',
        writer: '',
        medicalHistory: [],
        medicationStatus: '',
        medicationStatusOral: '',
        medicationStatusInfection: '',
        medicationStatusHaveInfection: '',
        medicationStatusOtherwise: '',
        physicalConditionGeneralState: '',
        physicalConditionNutritionalStatus: '',
        physicalConditionOralConditionsArtificialTooth: '',
        physicalConditionOralConditionsHaveArtificialTooth: '',
        physicalConditionOralConditionsToothache: '',
        physicalConditionOralConditionsSmarting: '',
        physicalConditionOralConditionsUpsetPain: '',
        physicalConditionOralConditionsInflammationOfGums: '',
        physicalConditionOralConditionsBadBreath: '',
        physicalConditionOralConditionsFoodResidue: '',
        physicalConditionOtherwise: '',
        physicalConditionDegreeOfDisability: '',
        sleep: '',
        sleepTimeOfSleeping: '',
        lifeHistory: '',
        preferenceDrinking: '',
        preferenceDrinkingAmount: '',
        preferenceSmoking: '',
        preferenceSmokingAmount: '',
        socialActivitiesMaladaptiveToThePopulation: '',
        socialActivitiesHomeroleAndDailyRoutine: [],
        socialActivitiesAboutGoingOut: '',
        socialActivitiesAlternatingCurrent: '',
        socialActivitiesHobby: '',
      },
    }
  },
  props: {
    propsFormData: {
      type: Object,
      required: true,
    },
    setObjectKey: {
      type: String,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    nextPageTitle: {
      type: String,
      required: false,
    },
    childName: {
      type: String,
      required: false,
    },
    schoolYear: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleUpdateArrayValue(setArrayKey, setKey, index, setValue) {
      this.formData[setArrayKey][index][setKey] = setValue
      this.handleUpdateValue(setArrayKey, this.formData[setArrayKey])
    },
    handleAddArray(setArrayKey, targetValue) {
      this.formData[setArrayKey].push(targetValue)
      this.handleUpdateValue(setArrayKey, this.formData[setArrayKey])
    },
    handleRemoveArray(setArrayKey, targetIndex) {
      this.formData[setArrayKey].splice(targetIndex, 1)
      this.handleUpdateValue(setArrayKey, this.formData[setArrayKey])
    },
    handleUpdateValue(setKey, setVal) {
      this.formData[setKey] = setVal
      this.$emit('input-emit', this.setObjectKey, setKey, setVal)
    },
    handlePrevTabs() {
      this.handleSmoothScroll()
      this.tabs--
    },
    handleNextTabs() {
      this.handleSmoothScroll()
      this.tabs++
    },
    handleSmoothScroll() {
      this.$smoothScroll({
        scrollTo: document.getElementById('app'), // scrollTo is also allowed to be number
      })
    },
    handleUpdateFormTab() {
      this.$emit('click-tab-switch', this.setObjectKey)
    },
    goToPage(tab) {
      this.tabs = tab
    },
  },
  mounted() {
    Object.keys(this.formData).forEach(key => {
      if (this.propsFormData[key]) {
        this.formData[key] = this.propsFormData[key]
      }

      this.handleUpdateValue(key, this.formData[key])
    })

    if (!this.formData.createdDate) {
      this.formData.createdDate = formUtils.handleSetJapaneseCalendar(
        new Date(),
        '',
        'none'
      )
      this.handleUpdateValue('createdDate', this.formData.createdDate)
    }
  },
}
</script>

<style lang="scss" scoped>
.content .form-wrap {
  margin-bottom: 30px;
}
</style>
<style lang="scss" scoped>
.form-tabs {
  margin: 0 auto;
  max-width: 460px;
  button {
    width: 100%;
  }
}
</style>
